import { render, staticRenderFns } from "./MeetingConvocationsMailPopup.vue?vue&type=template&id=01bbc832&"
import script from "./MeetingConvocationsMailPopup.vue?vue&type=script&lang=js&"
export * from "./MeetingConvocationsMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports